import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';
import { EngagementLiteComponent } from '../../../../shared/components/engagement/engagement-lite/engagement-lite.component';
import { EngagementProComponent } from '../../../../shared/components/engagement/engagement-pro/engagement-pro.component';
import { EngagementDetailsComponent } from '../../../../shared/components/engagement/engagement-details/engagement-details.component';
import { EngagementSummaryComponent } from '../../../../shared/components/engagement/engagement-summary/engagement-summary.component';
import {
  getShowComparisonFlag,
  setShowComparisonFlag,
} from '../../../../shared/utils/score-deviation.util';

@Component({
    selector: 'app-account-engagement-home',
    templateUrl: './account-engagement-home.component.html',
    styleUrls: ['./account-engagement-home.component.scss'],
    imports: [NgIf, NgClass, EngagementLiteComponent, EngagementProComponent, EngagementDetailsComponent, EngagementSummaryComponent, AsyncPipe]
})
export class AccountEngagementHomeComponent {
  params: any = '';
  tabs: string[] = [];
  activeTab: string = '';
  queryParams$: Observable<any> = of({});
  tabVisiblity: any = {
    lite: Helpers.isTabVisible(true, 'engagement', 'summary'),
    pro: Helpers.isTabVisible(true, 'engagement', 'summary_v2'),
    details: Helpers.isTabVisible(true, 'engagement', 'comparison_v2'),
    summary: Helpers.isTabVisible(true, 'engagement', 'summary') || Helpers.isTabVisible(true, 'engagement', 'summary_v2')
  };
  showRecordsJourney: boolean = false;
  showResponseDistribution: boolean = false;
  isDeviationEnabled = false;
  showDeviationToggle = false;

  constructor(private router: Router, private route: ActivatedRoute, private helpersService: HelpersService) { }

  ngOnInit(): void {
    this.tabVisiblity = {
      lite: Helpers.isTabVisible(true, 'engagement', 'summary'),
      pro: Helpers.isTabVisible(true, 'engagement', 'summary_v2'),
      details: Helpers.isTabVisible(true, 'engagement', 'comparison_v2'),
      summary: Helpers.isTabVisible(true, 'engagement', 'summary') || Helpers.isTabVisible(true, 'engagement', 'summary_v2')
    };
    
    if (this.tabVisiblity.lite) this.tabs.push('lite');
    if (this.tabVisiblity.pro) this.tabs.push('pro');
    if (this.tabVisiblity.details) this.tabs.push('details');
    if (this.tabVisiblity.summary)this.tabs.push('summary');

    let activeTab = (this.tabs && this.tabs.length) ? this.tabs[0] : '';

    this.updateDeviationToggleVisibility(Helpers.datePicker);
    this.helpersService.datePicker.subscribe((datePicker: any) => {
      this.updateDeviationToggleVisibility(datePicker);
    });

    this.route.queryParams.subscribe(params => {
      this.params = params;
      if (this.params["account_id"]) {
        if (this.tabs.includes(this.params['active_tab'])) {
          this.activeTab = this.params['active_tab'] || activeTab;
          this.onClickingNavigation(this.activeTab);
        } else {
          this.activeTab = activeTab;
          this.onClickingNavigation(this.activeTab);
        }
      } else {
        console.log('Redirect to broken link page!');
      }

      // Remove localStorage values if current tab is not in tabs
      if (!this.tabs.includes(this.params['active_tab'])) {
        localStorage.removeItem('showRecordsJourney');
        localStorage.removeItem('showResponseDistribution');
        localStorage.removeItem('showChannelPerformance');
        this.showRecordsJourney = false;
        this.showResponseDistribution = false;
      }
    });
  }

  onClickingNavigation(str: string) {
    this.activeTab = str;
    if (this.showDeviationToggle) {
      this.isDeviationEnabled = getShowComparisonFlag();
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: str },
      queryParamsHandling: 'merge'
    });
  }

  onDeviationToggle(event: Event) {
    if (this.showDeviationToggle) {
      this.isDeviationEnabled = (event.target as HTMLInputElement).checked;
      setShowComparisonFlag(this.isDeviationEnabled);
    }
  }

  private updateDeviationToggleVisibility(datePicker: any): void {
    this.showDeviationToggle = !!(datePicker?.isPresetActive && !datePicker?.isCustomDateRangeSelected);
    if (!this.showDeviationToggle) {
      this.isDeviationEnabled = false;
      setShowComparisonFlag(false);
    } else {
      this.isDeviationEnabled = getShowComparisonFlag();
    }
  }
}
